import moment from "moment";

// filter function to convert °C to °F for specific language
export const tempConvertFunc = value => {
  const lang = localStorage.getItem("language");
  if (lang && lang === "us") {
    return Math.round(value * 1.8 + 32);
  }
  return value;
};

// filter function to convert kg to lbs for specific language
export const weightConvertFunc = value => {
  const lang = localStorage.getItem("language");
  if (lang && lang === "us") {
    return (value / 0.45359237).toFixed(0);
  }
  return value;
};

// filter function to convert °C to °F and handle the slider's deciaml part
export const onSliderTempConvertFunc = value => {
  const lang = localStorage.getItem("language");
  if (lang && lang === "us") {
    let convertedValue = Math.round(value * 1.8 + 32);
    let decimals = value - Math.floor(value);
    return Number(convertedValue) + Number(decimals.toFixed(1));
  }
  return value;
};

// change the format of date string
export const dateFormat = (value, format) => {
  if (value) {
    return moment(value).format(format);
  }
  return value;
};
